import React from 'react'

import daysToMonths from '../../../utils/daysToMonths'
import { Charts, DaysToDisposition, TransformLine } from '../types'
import { ChartProps } from '../types'
import LineChart from './LineChart'
import LineChartSkeletonLoader from './LineChartSkeletonLoader'
import PlatformChartContainer from './PlatformChartContainer'

const transform: TransformLine<DaysToDisposition> = (datum) =>
  datum.map(({ data, ...item }) => ({
    ...item,
    data: data
      .sort((current, next) => current.year - next.year)
      .map(({ daysToDisposition, year }) => ({
        x: year,
        y: daysToMonths(daysToDisposition ?? 0),
      })),
  }))

const MonthsToDisposition: React.FC<ChartProps> = (props) => (
  <PlatformChartContainer
    chart={Charts.DaysToDispositionOverTime}
    exportableConfig={{
      filename: 'months_to_disposition',
      getData: (data) => {
        const years = data[0].data.map(({ year }) => year)

        return data.map((item) => {
          const datapoints = years.map((year) =>
            item.data.find(({ year: datumYear }) => year === datumYear)
          )

          return [
            item.id,
            ...datapoints.map((datapoint) =>
              datapoint ? daysToMonths(datapoint.daysToDisposition ?? 0).toFixed(1) : ''
            ),
          ]
        })
      },
      getHeader: (data) => data[0].data.map(({ year }) => year),
    }}
    skeleton={LineChartSkeletonLoader}
    title="Months To Disposition"
    {...props}
  >
    {({ data: raw, ...dimensions }) => {
      const data = transform(raw)

      return (
        <LineChart
          {...dimensions}
          axisBottom={{
            legend: 'Disposition Year',
          }}
          axisLeft={{
            legend: 'Months To Disposition',
          }}
          data={data}
          tooltipFormat="1.1f"
        />
      )
    }}
  </PlatformChartContainer>
)

export default MonthsToDisposition
